import React,{Component} from 'react';
import dayjs from 'dayjs';
import PeopleList from './PeopleList'

class PostingListItem extends Component{

  constructor(props){
    super(props);

    this.state ={posting:this.props.posting,showPeople :false};
    this.saveGroup = this.saveGroup.bind(this);
    this.deletePosting = this.deletePosting.bind(this);
    this.saveGroup = this.saveGroup.bind(this);
    this.deletePerson = this.deletePerson.bind(this);
    this.createNewToken = this.createNewToken.bind(this);
    this.updateInputValue = this.updateInputValue.bind(this);
    this.addPerson = this.addPerson.bind(this);
  
  }
  updateInputValue(evt) {
    let inputName =  evt.target.name;

    let posting2= this.state.posting;
    posting2[inputName]= evt.target.value;
    this.setState({posting:posting2});
   
   }

   saveGroup(){

      const posting = this.state.posting;
      console.log(posting);
      this.props.savePosting(posting);
      
  }

    

   
   deletePerson(person,i){
    let posting = this.state.posting;
    posting.people.splice(i,1);
    console.log(posting);
    this.props.savePosting(posting);
   }
   createNewToken(){
    const posting = this.state.posting;
    console.log(posting);
    this.props.savePosting(posting,true);
   }
   deletePosting(){
    const posting = this.state.posting;
    this.props.deletePosting(posting);
   }

 addPerson(){
    // Luo uusi ryhmäobjekti päivitettynä ja aseta se tilaan
    let newPeople = this.state.posting.people;
    newPeople.push("");
    let updatedPosting = this.state.posting;
    updatedPosting.people = newPeople;
    const updatedPosting2 = updatedPosting;
    this.setState({posting: updatedPosting2});
    this.props.savePosting(updatedPosting);
  };

 
  render(){
   let styleClass = "workerListItem";
   let messageWithOnlyToken = "Hei. Tässä linkki työjaksoon ilmoittautumiseen. Ilmoitathan kun työjakso loppuu ja mahdolliset majoitus muutokset. https://forestlogbook.herokuapp.com/posting?accessToken=" + this.state.posting.accessToken;
   let smsLinkWithToken = "sms://" + this.props.posting.responsiblePhone + "/?body=" + encodeURIComponent(messageWithOnlyToken);
   const people = this.props.posting.people != undefined ? this.props.posting.people.map( (i,index) => {
      return (  <div style={{width: "100%",display: "inline-block", textAlign: "left",marginTop: "10px"}}>{i}</div> )
    }): null;
      
    const arrivalDate = dayjs(this.state.posting.arrivalDate).format('YYYY-MM-DD');
    const workEnded = dayjs(this.state.posting.workEnded).format('YYYY-MM-DD');

      return (
        <>
        <tr key={this.props.posting._id}  id={this.props.posting._id} style={this.state.posting.accessToken === "" ? {backgroundColor:"rgb(153, 114, 114)"}:{}} >
              
              <td ><input type="text" name="groupname" value={this.state.posting.groupname} onChange={this.updateInputValue} onBlur={this.saveGroup} style={{float: "left"}}/></td>
              
              <td ><input type="text" name="responsiblePhone" value={this.state.posting.responsiblePhone} onChange={this.updateInputValue}  onBlur={this.saveGroup} style={{float: "left"}}/></td>
              <td ><input type="text" name="responsible" value={this.state.posting.responsible} onChange={this.updateInputValue}  onBlur={this.saveGroup} style={{float: "left"}}/></td>
              <td ><input type="text" name="worktime" value={this.state.posting.worktime} onChange={this.updateInputValue} onBlur={this.saveGroup} style={{float: "left"}}/></td>
              <td ><input type="date" name="arrivalDate" value={arrivalDate} onChange={this.updateInputValue}  onBlur={this.saveGroup} style={{float: "left"}}/></td>
              <td ><input type="date" name="workEnded"  value={workEnded}  onChange={this.updateInputValue}  onBlur={this.saveGroup} style={{float: "left"}}/></td>
              
              <td ><input type="text" name="commondation" value={this.state.posting.commondation} onChange={this.updateInputValue}  onBlur={this.saveGroup} style={{float: "left"}}/></td>
            
              <td style={{width: "100px;"}}><button onClick={() => this.setState({showPeople:!this.state.showPeople})} title="Jäsenet">&#128101;</button><a href={smsLinkWithToken}><button title="Lähetä linkki">&#x1F4E7;</button></a><button title="Luo uusi linkki" onClick={this.createNewToken}>&#x1F504;</button><button onClick={this.deletePosting} title="Poista ryhmä">&#10060;</button></td>

        </tr>
        <tr>
          <td colSpan={8}> {this.state.showPeople && <><div className="" style={{marginBottom: "10px", width:"60%",display:"inline-block",textAlign: "left"}}>Ryhmän jäsenet</div><div style={{width:"40%",display:"inline-block"}}><button onClick={this.addPerson}>&#10133;</button></div></>}</td>
      </tr>
        <tr>
          <td colSpan={8}> {this.state.showPeople && people !== null && people !== undefined && <PeopleList saveGroup={this.saveGroup} group={this.props.posting} deletePerson={this.deletePerson}/>}</td>
      </tr>
   </>
      )

  }
}
export default PostingListItem;
